import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {PhoneAndEmailFactoryService} from "../../../commons/services/phone-and-email-factory.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AccountUploadEditViewCtrl implements IController {

  account: AccountModel;
  onCancel: Function;
  onSave: Function;

  private country: any;
  private accountCopy: any;

  /* @ngInject */
  constructor(private phoneAndEmailFactoryService: PhoneAndEmailFactoryService, private splitService: SplitService, private $filter: IFilterService) {
    this.country = this.splitService.getCountryCode();
  }

  $onInit() {
    this.accountCopy = angular.copy(this.account);
  };

  onAddressChange(address) {
    if (_.isUndefined(this.accountCopy.entity.address)) {
      _.set(this.accountCopy, 'entity.address', {})
    }
    this.accountCopy.entity.address = address;
  }

  onPhoneChange(phoneNumber, form) {
    this.phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, this.country, form, 'phoneNumber');
  }

  onSubmit(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.accountCopy.errors = _.filter(this.accountCopy.errors, (error) => {
          return error.fieldName === 'server';
        });
        this.accountCopy.entity.phoneNumber = this.$filter<any>('bringozPhonePrefix')(this.accountCopy.entity.phoneNumber);
        this.onSave({account: this.accountCopy});
      }
    }
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountUploadEditView', {
    bindings: {
      account: '<',
      onCancel: '&',
      onSave: '&'
    },
    template: require('./account-upload-edit-view.html').default,
    controller: AccountUploadEditViewCtrl
  });
